(function() {
    function funcReady() {

    // BTOCSITE-25511 비디오플레이 컨트롤 커스텀
	var supportsVideo = !!document.createElement('video').canPlayType;

	if (supportsVideo) {
		// var video = document.getElementById('video');
		// var videoControls = document.getElementById('video-controls');
        //
		// video.controls = false;
        //
		// videoControls.setAttribute('data-state', 'visible');
        //
		// var playpause = document.getElementById('playpause');
		// var mute = document.getElementById('mute');
        //
		// if (document.addEventListener) {
		// 	var changeButtonState = function(type) {
		// 		if (type == 'playpause') {
		// 			if (video.paused || video.ended) {
		// 				playpause.setAttribute('data-state', 'play');
		// 			}
		// 			else {
		// 				playpause.setAttribute('data-state', 'pause');
		// 			}
		// 		}
		// 		else if (type == 'mute') {
		// 			mute.setAttribute('data-state', video.muted ? 'unmute' : 'mute');
		// 		}
		// 	}
        //
		// 	video.addEventListener('play', function() {
		// 		changeButtonState('playpause');
		// 	}, false);
		// 	video.addEventListener('pause', function() {
		// 		changeButtonState('playpause');
		// 	}, false);
        //
		// 	playpause.addEventListener('click', function(e) {
		// 		if (video.paused || video.ended) video.play();
		// 		else video.pause();
		// 	});
        //
		// 	mute.addEventListener('click', function(e) {
		// 		video.muted = !video.muted;
		// 		changeButtonState('mute');
		// 	});
		// }

        // 음성 컨트롤
        $('.btnVideoCtrl').click(function(){
            var id= $(this).attr('id');
            var state = $(this).data('state');
            var modifyState = '';

            // 음성 컨트롤
            if("mute" == id){
                if(state == 'unmute' ){
                    $(this).parent().parent().children('video').prop('muted', false);
                    modifyState = 'mute';
                }else{
                    $(this).parent().parent().children('video').prop('muted', true);
                    modifyState = 'unmute';
                }
            }else { // 동영상 컨트롤
                if(state == 'play' ){
                    $(this).parent().parent().children('video').get(0).pause();
                    modifyState = 'pause';
                }else{
                    $(this).parent().parent().children('video').get(0).play();
                    modifyState = 'play';
                }
            }

            $(this).data('state' , modifyState);
            $(this).attr('data-state', modifyState);
        });



    }
    //  //BTOCSITE-25511 비디오플레이 컨트롤 커스텀

        // if(!document.querySelector('.KRC1100')) return false;

        // $('.KRC1100').buildCommonUI();

        vcui.require(['libs/lazyLoaderSwitchVideo.min', 'libs/lodash-1.8.3.min', 'libs/gsap-3.10.4.min', 'libs/ScrollTrigger-3.10.4.min', 'ui/carousel', 'libs/swiper-8.2.4.min'], function () { // BTOCSITE-66808 상품 PDP관련 스크립트 변경 (swiper)
            function isMobile() {
                return window.matchMedia("(max-width: 767px)").matches;
            }

            // 카드 디스클라이머 높이 맞춤
            var cardPadding = {
                set: function() {
                    if (!isMobile()) {
                        $('.usp-card.pc-col2').each(function(item) {
                            if ($(this).hasClass('dc-exist')) {
                                item % 2 === 0 ? $('.usp-card.pc-col2').eq(item + 1).addClass('dc-copy') : $('.usp-card.pc-col2').eq(item - 1).addClass('dc-copy');
                            }
                        });
                    } else {
                        $('.usp-card.pc-col2').removeClass('dc-copy');
                    }
                },
                init: function() {
                    var self = this;

                    self.set();
                    $(window).on('load breakpointchange', function() {
                        self.set();
                    });
                },
            }

            cardPadding.init();

            // 카드 목록 영역 마진
            var cardMargin = {
                set: function() {
                    if ($('.usp-card-wrap').find('.card-items-area').length > 0 && $('.usp-card-wrap').find('.cover-area-wrap').length > 0) {
                        $('.usp-card-wrap').find('.card-items-area').eq(0).addClass('top-area');
                    }
                },
                init: function() {
                    var self = this;

                    $(window).on('load breakpointchange', function() {
                        self.set();
                    });

                    // [상품] [BTOCSITE-61289] (KRC1100) USP Card 컴포넌트 여백 수정 검토 요청
                    $('.usp-card-wrap').each(function(){
                        var cardItem = $(this).find('.card-items-area > div').length;
                        if( cardItem == 0 ) {
                            $(this).find('.card-items-area').css('margin', 0);
                        }
                    })
                },
            }

            cardMargin.init();

            // 팝업
            var popup = {
                show: function($modal, $button) {
                    var self = this;

                    $('.detail-layer').hide().css({ top: '100%', opacity: '0' }).attr('data-popup-state', 'false');
                    $('html, body').css({ overflow: 'hidden' });

                    if ($button) {
                        $modal.data('data-popup-focus', $button);
                    } else {
                        $modal.data('data-popup-focus', false);
                    }
                    $modal.find('.detail-area').find('.close-btn').attr('tabindex', '0');
                    $modal.find('.detail-area').find('.detail-wrap').attr('tabindex', '0');

                    if (isMobile()) {
                        $modal.show(0, function() {
                            self.masking($(this));
                            $(this).find('.detail-wrap').scrollTop(0);
                            $(this).animate({ top: '0' }, 300);
                        }).css('opacity', '1').attr('data-popup-state', 'true');
                    } else {
                        $modal.show(0, function() {
                            self.masking($(this));
                            $(this).find('.detail-wrap').scrollTop(0);
                            $(this).animate({ opacity: '1' }, 300);
                        }).css('top', '0').attr('data-popup-state', 'true');
                    }

                    if ($modal.find('.gallery-slide').length > 0) {
                        $modal.find('.gallery-slide').each(function() {
                            this.swiper.update();
                        });
                    }

                    $modal.find('.detail-area').find('.detail-wrap').focus();

                    self.currentTrigger = self.video();
                },
                hide: function($modal) {
                    var self = this;

                    if (isMobile()) {
                        $modal.animate({ top: '100%' }, 300, function() {
                            $(this).hide().css({ opacity: '0' }).attr('data-popup-state', 'false');
                        });
                    } else {
                        $modal.animate({ opacity: '0' }, 300, function() {
                            $(this).hide().css({ top: '100%' }).attr('data-popup-state', 'false');
                        });
                    }

                    $('html, body').css({ overflow: 'visible' });
                    // $('.detail-layer').hide().css({ top: '100%', opacity: '0' }).attr('data-popup-state', 'false');

                    if ($modal.data('data-popup-focus')) {
                        $modal.data('data-popup-focus').focus();
                    }

                    $modal.data('data-popup-focus', false);

                    $modal.find('.detail-area').find('.close-btn').removeAttr('tabindex');
                    $modal.find('.detail-area').find('.detail-wrap').removeAttr('tabindex');

                    $modal.find('video').each(function() {
                        this.pause();
                        this.currentTime = 0;
                    });

                    if (Array.isArray(self.currentTrigger)) {
                        self.currentTrigger.forEach(function(el) {
                            el[0].kill();
                            el[1].kill();
                        });
                    }

                    self.currentTrigger = null;
                },
                change: function($modal) {
                    var self = this;

                    if (isMobile()) {
                        $('.detail-layer').filter('[data-popup-state="true"]').animate({ top: '100%' }, 300, function() {
                            $(this).hide().css({ opacity: '0' }).attr('data-popup-state', 'false');
                            $(this).find('.close-btn').removeAttr('tabindex');
                            $(this).find('.detail-wrap').removeAttr('tabindex');
                            $(this).find('video').each(function() {
                                this.pause();
                                this.currentTime = 0;
                            });
                            $modal.show(0, function() {
                                self.masking($(this));
                                $(this).find('.detail-wrap').scrollTop(0);
                                $(this).animate({ top: '0' }, 300);
                                $(this).find('.detail-area').find('.close-btn').attr('tabindex', '0');
                                $(this).find('.detail-area').find('.detail-wrap').attr('tabindex', '0');
                                $(this).find('.detail-area').find('.detail-wrap').focus();
                            }).css({ opacity: '1' }).attr('data-popup-state', 'true');

                            if (Array.isArray(self.currentTrigger)) {
                                self.currentTrigger.forEach(function(el) {
                                    el[0].kill();
                                    el[1].kill();
                                });
                            }

                            self.currentTrigger = self.video();
                        });
                    } else {
                        $('.detail-layer').filter('[data-popup-state="true"]').animate({ opacity: '0' }, 300, function() {
                            $(this).hide().css({ top: '100%' }).attr('data-popup-state', 'false');
                            $(this).find('.close-btn').removeAttr('tabindex');
                            $(this).find('.detail-wrap').removeAttr('tabindex');
                            $(this).find('video').each(function() {
                                this.pause();
                                this.currentTime = 0;
                            });
                            $modal.show(0, function() {
                                self.masking($(this));
                                $(this).find('.detail-wrap').scrollTop(0);
                                $(this).animate({ opacity: '1' }, 300);
                                $(this).find('.detail-area').find('.close-btn').attr('tabindex', '0');
                                $(this).find('.detail-area').find('.detail-wrap').attr('tabindex', '0');
                                $(this).find('.detail-area').find('.detail-wrap').focus();
                                // if ($(this).find('.card-detail-slide-wrap').length > 0) {
                                //     $(this).find('.card-detail-slide-wrap').each(function() {
                                //         $(this).data('ui_carousel').update();
                                //     });
                                // }
                                if ($(this).find('.gallery-slide').length > 0) {
                                    $(this).find('.gallery-slide').each(function() {
                                        this.swiper.update();
                                    });
                                }
                            }).css({ top: '0' }).attr('data-popup-state', 'true');

                            if (Array.isArray(self.currentTrigger)) {
                                self.currentTrigger.forEach(function(el) {
                                    el[0].kill();
                                    el[1].kill();
                                });
                            }

                            self.currentTrigger = self.video();
                        });
                    }

                    // self.currentTrigger.forEach(function(el) {
                    //     el[0].kill();
                    //     el[1].kill();
                    // });

                    // self.currentTrigger = self.video();
                },
                menu: function() {
                    var self = this;
                    var popupFooterList = $(document.createElement('ul')).addClass('list');

                    $('.card-items-area .usp-card[data-popup-id]').each(function() {
                        if ($('.card-detail-area .detail-layer').filter('[data-popup-id="' + $(this).attr('data-popup-id') + '"]').length > 0) {
                            var popupFooterItem = $(document.createElement('li'));
                            var popupFooterLink = $(document.createElement('button')).attr('type', 'button');
                            var popupFooterText = $(this).find('.index-desc .txt').text();
                            var popupFooterId = $(this).attr('data-popup-id');
                            popupFooterList.append(popupFooterItem.append(popupFooterLink.text(popupFooterText)).attr('data-popup-id', popupFooterId));
                        }
                    });

                    $('.card-detail-area .detail-layer').each(function() {
                        var popupFooterWrap = $(this).find('.other-detail-view-wrap .inner-wrap');
                        var currentPopupId = $(this).attr('data-popup-id');
                        if (popupFooterWrap.find('ul.list').length > 0) {
                            popupFooterWrap.find('ul.list').remove()
                        }
                        popupFooterWrap.append(popupFooterList.clone());
                        popupFooterWrap.find('li[data-popup-id="' + currentPopupId + '"]').addClass('on');
                    });

                    $('.detail-layer .other-detail-view-wrap').on('click', '.list li button', function(e) {
                        e.preventDefault();
                        // if ($(this).closest('li').attr('data-popup-id') !== $(this).closest('.detail-layer').attr('data-popup-id')) {
                        if (!$(this).closest('li').hasClass('on')) {
                            self.change($('.detail-layer').filter('[data-popup-id="' + $(e.target).closest('li').attr('data-popup-id') + '"]'));
                        } else {
                            self.masking($(this));
                            $(this).closest('.detail-wrap').animate({ scrollTop: 0 }, 300);
                        }
                    });
                },
                masking: function($popup) {
                    var maxHeight = {
                        descSubBox: '',
                        descMainBox: '',
                    };

                    if ($popup.find('.desc-sub-box').length > 0) {
                        maxHeight.descSubBox = Number($popup.find('.desc-sub-box').addClass('masking').eq(0).find('.inner').css('max-height').replaceAll(/px/g, ''));
                        $popup.find('.desc-sub-box').removeClass('masking').each(function() {
                            if ($(this).find('.inner').height() <= maxHeight.descSubBox) {
                                $(this).find('.more-view').remove();
                            } else {
                                $(this).addClass('masking');
                            }
                        });
                    }

                    if ($popup.find('.desc-main-box').length > 0) {
                        // maxHeight.descMainBox = Number($popup.find('.desc-main-box').addClass('masking').eq(0).find('.inner').css('max-height').replaceAll(/px/g, ''));
                        // $popup.find('.desc-main-box').removeClass('masking').each(function() {
                        //     if ($(this).find('.inner').height() <= maxHeight.descMainBox) {
                        //         $(this).find('.more-view').remove();
                        //     } else {
                        //         $(this).addClass('masking');
                        //     }
                        // });
                        $popup.find('.desc-main-box .more-view').hide();
                    }
                },
                currentTrigger: null,
                video: function() {
                    var self = this;
                    var popup = $('.detail-layer[data-popup-state="true"]');
                    var videoTrigger = [];

                    // 팝업 비디오 상태값 초기화 추가(BTOCSITE-25511)
                    $('#playpause').data('state' , 'play');
                    $('#playpause').attr('data-state', 'play');

                    $('#mute').parent().parent().children('video').prop('muted', true);
                    $('#mute').data('state' , 'unmute');
                    $('#mute').attr('data-state', 'unmute');

                    gsap.utils.toArray(popup.find('video')).forEach(function(el, index) {
                        // var q = gsap.utils.selector(el);

                        var startTrigger = ScrollTrigger.create({
                            trigger: el,
                            start: 'top 50%',
                            end: 'bottom 10%',
                            scroller: popup.find('.detail-wrap'),
                            // markers: {
                            //     startColor: 'black',
                            //     endColor: 'black',
                            // },
                            onEnter: function() {
                                if (el.paused) {
                                    el.play();
                                }
                            },
                            onEnterBack: function() {
                                if (el.paused) {
                                    el.play();
                                }
                            },
                        });

                        var endTrigger  = ScrollTrigger.create({
                            trigger: el,
                            start: 'top bottom',
                            end: 'bottom top',
                            scroller: popup.find('.detail-wrap'),
                            // markers: {
                            //     startColor: 'red',
                            //     endColor: 'red',
                            // },
                            onLeave: function() {
                                if (!el.paused) {
                                    el.pause();
                                    el.currentTime = 0;
                                }
                            },
                            onLeaveBack: function() {
                                if (!el.paused) {
                                    el.pause();
                                    el.currentTime = 0;
                                }
                            },
                        });

                        videoTrigger.push([startTrigger, endTrigger]);
                    });
                    return videoTrigger;
                },
                currentCarousel: [],
                carousel: function() {
                    var self = this;

                    $('.detail-layer .detail-wrap .gallery-slide').each(function() {
                        var dataText = $(this).attr('data-text') ? $(this).attr('data-text') : '';
                        var currentSwiper = new Swiper(this, {
                            slidesPerView: 'auto',
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true,
                                renderBullet: function(index, className) {
                                    return '<button type="button" class="' + className + '" data-contents="' + dataText + '"><span class="blind">' + (index + 1) + '번 내용 보기</span></button>'; //BTOCSITE-79476 [웹앱 접근성 개선활동] 상품_PDP>WCMS USP 컴포넌트
                                },
                            },
                        });
                        self.currentCarousel.push(currentSwiper);
                    });

                    // self.currentCarousel = new Swiper('.detail-layer .detail-wrap .gallery-slide', {
                    //     slidesPerView: 'auto',
                    //     pagination: {
                    //         el: '.swiper-pagination',
                    //         type: 'bullets',
                    //         clickable: true,
                    //         renderBullet: function(index, className) {
                    //             return '<span class="' + className + '"><span class="blind">' + (index + 1) + '번 내용 보기</span></span>';
                    //         },
                    //     },
                    // });
                },
                init: function() {
                    var self = this;

                    self.menu();
                    self.carousel();

                    $('.detail-layer').hide().css({ top: '100%', opacity: '0' }).attr('data-popup-state', 'false');

                    $('.card-items-area .usp-card .index-desc button').on('click', function(e) {
                        e.preventDefault();
                        if ($('.detail-layer').filter('[data-popup-id="' + $(e.target).closest('.usp-card').attr('data-popup-id') + '"]').length > 0) {
                            self.show($('.detail-layer').filter('[data-popup-id="' + $(e.target).closest('.usp-card').attr('data-popup-id') + '"]'), $(e.target));
                        }
                    });

                    $('.detail-layer .close-btn').on('click', function(e) {
                        e.preventDefault();
                        self.hide($('.detail-layer').filter('[data-popup-id="' + $(e.target).closest('.detail-layer').attr('data-popup-id') + '"]'));
                    });

                    // $(document).on('keydown', function(e) {
                    //     var isTabPressed = e.key === 'Tab' || e.keyCode === 9;
                    //     var isModalOpened = $('.detail-layer[data-popup-state="true"]').length > 0;

                    //     if (isTabPressed && isModalOpened) {
                    //         var focusableList = $('.detail-layer[data-popup-state="true"] .detail-area').children('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    //         // var focusableList = $('.detail-layer[data-popup-state="true"] .detail-area').find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
                    //         if (e.shiftKey) {
                    //             if (document.activeElement === focusableList.first()[0]) {
                    //                 focusableList.last().focus();
                    //                 e.preventDefault();
                    //             }
                    //         } else {
                    //             if (document.activeElement === focusableList.last()[0]) {
                    //                 focusableList.first().focus();
                    //                 e.preventDefault();
                    //             }
                    //         }
                    //     }
                    // });

                    // 더보기
                    $('.desc-sub-box .more-view').off('click').on('click', function(e) {
                        e.preventDefault();
                        $(e.target).closest('.desc-sub-box').toggleClass('masking');
                    });

                    // $('.desc-main-box .more-view').on('click', function(e) {
                    //     e.preventDefault();
                    //     $(e.target).closest('.desc-main-box').toggleClass('masking');
                    // });

                    // 캐러셀
                    // $('.card-detail-slide-wrap').each(function() {
                    //     $(this).data('ui_carousel').setOption({variableWidth: true, adaptiveHeight: false});
                    //     $(this).data('ui_carousel').update();
                    // });
                },
            }

            popup.init();

            function controlVideo(state, el, idx, hover) {
                var videoList = $(el).find('video');
                var videoItem = $(el).eq(idx).find('video');

                if (videoItem.length > 0) {
                    if (hover) {
                        switch (state) {
                            case 'play':
                                if (!videoItem[0].pausedHover) {
                                    videoItem[0].pausedHover = true;
                                    videoItem.on('mouseenter.videoHover', function() {
                                        videoItem[0].currentTime = 0;
                                        this.play();
                                    });
                                }
                                break;
                            case 'pause':
                                if (!videoItem[0].paused) {
                                    videoItem[0].pause();
                                    videoItem[0].currentTime = 0;
                                }
                                if (videoItem[0].pausedHover) {
                                    videoItem[0].pausedHover = false;
                                    videoItem.off('.videoHover');
                                }
                                break;
                        }
                    } else {
                        switch (state) {
                            case 'play':
                                if (videoItem[0].paused) {
                                    videoItem[0].currentTime = 0;
                                    videoItem[0].play();
                                }
                                break;
                            case 'pause':
                                if (!videoItem[0].paused) {
                                    videoItem[0].pause();
                                    videoItem[0].currentTime = 0;
                                }
                                break;
                        }
                    }
                }
            }

            // 비디오 지연로딩
            $('body').vcLazyLoaderSwitchVideo();

            $(window).on('load breakpointchange', function() {
                ScrollTrigger.refresh();
            });

            $(window).on('breakpointchange', function() {
                $('body').data('ui_lazyLoaderSwitch').reload($('body'));
                $('body').data('ui_lazyLoaderSwitchVideo').reload($('body'));
            });

            $(window).on('resize', _.debounce(function() {
                ScrollTrigger.refresh();
                if (popup.currentCarousel && popup.currentCarousel.length > 0) {
                    popup.currentCarousel.forEach(function(swiper) {
                        swiper.update();
                    });
                }
            }, 100));

            // scrolltrigger
            gsap.registerPlugin(ScrollTrigger);

            // Product Cover
            ScrollTrigger.matchMedia({
                // 모바일
                "(max-width: 767px)": function() {
                    gsap.to('.cover-area', {
                        scrollTrigger: {
                            trigger: '.cover-area',
                            // markers: true,
                            start: 'bottom 90%',
                            end: 'bottom 20%',
                            scrub: true,
                            invalidateOnRefresh: true,
                        },
                        y: -100,
                        ease: 'none',
                    });

                    // BTOCSITE-36045 모바일 영상 세로 관련 추가
                    gsap.to('.cover-area .detail-info', {
                        scrollTrigger: {
                            trigger: '.cover-area .detail-info',
                            start: 'bottom 90%',
                            end: 'bottom 20%',
                            scrub: true,
                            invalidateOnRefresh: true,
                        },
                        y: 50,
                        ease: 'none',
                    });
                },
            });

            // Concept Card - Scroll type
            ScrollTrigger.matchMedia({
                // 모바일
                "(max-width: 767px)": function() {
                    gsap.utils.toArray('.usp-card.scroll-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);
                        var cardLength = $(el).find('.img-wrap .img').length - 1;
                        var txtHeight = $(el).find('.txt-wrap .txt-desc').length > 0 ? $(el).find('.txt-wrap .txt-desc').eq(0).outerHeight() : $(el).height();
                        var tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                pin: q('.item-wrap'),
                                // pin: true,
                                pinSpacing: true,
                                // markers: true,
                                start: function() { return ($(window).height() > ($(el).height() + $(window).height() * 0.2) ? 'top 10%' : 'top 10px') },
                                end: function() { return ('bottom -' + cardLength * txtHeight + 'px') },
                                scrub: true,
                                invalidateOnRefresh: true,
                            },
                            defaults: {
                                ease: 'none',
                            },
                        });

                        // gsap.set(q('.txt-wrap'), { top: 0 })
                        gsap.set(q('.txt-wrap .txt-desc')[0], { marginTop: 0 })
                        gsap.set(q('.img-wrap .img'), { autoAlpha: 0 })
                        gsap.set(q('.img-wrap .img')[0], { autoAlpha: 1 });

                        tl.call(controlVideo, ['play', q('.img-wrap .img'), 0], '<');

                        for (var i=0; i<cardLength; i++) {
                            tl.to(q('.txt-wrap .txt-desc')[i], {
                                marginTop: function() { return ('-=' + txtHeight / 2) },
                                duration: 0.5,
                            }, '>');

                            tl.to(q('.img-wrap .img')[i+1], {
                                autoAlpha: 1,
                                duration: 0.1,
                                onComplete: controlVideo,
                                onCompleteParams: ['play', q('.img-wrap .img'), i+1],
                                onReverseComplete: controlVideo,
                                onReverseCompleteParams: ['pause', q('.img-wrap .img'), i+1],
                            }, '>-0.2');

                            tl.to(q('.img-wrap .img')[i], {
                                autoAlpha: 0,
                                duration: 0.1,
                                onComplete: controlVideo,
                                onCompleteParams: ['pause', q('.img-wrap .img'), i],
                                onReverseComplete: controlVideo,
                                onReverseCompleteParams: ['play', q('.img-wrap .img'), i],
                            }, '>-0.1');

                            tl.to(q('.txt-wrap .txt-desc')[i], {
                                marginTop: function() { return ('-=' + txtHeight / 2) },
                                duration: 0.5,
                            }, '>');
                        }
                    });
                },

                // PC
                "(min-width: 768px)": function() {
                    gsap.utils.toArray('.usp-card.scroll-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);
                        var cardLength = $(el).find('.img-wrap .img').length - 1;
                        var txtHeight = $(el).find('.txt-wrap .txt-desc').length > 0 ? $(el).find('.txt-wrap .txt-desc').eq(0).outerHeight() : $(el).height();
                        var tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                pin: q('.item-wrap'),
                                // pin: true,
                                pinSpacing: true,
                                // markers: true,
                                start: '50% 50%',
                                end: function() { return ('bottom -' + cardLength * txtHeight + 'px') },
                                scrub: true,
                                invalidateOnRefresh: true,
                            },
                            defaults: {
                                ease: 'none',
                            },
                        });

                        // gsap.set(q('.txt-wrap'), { top: 0 })
                        gsap.set(q('.txt-wrap .txt-desc')[0], { marginTop: 0 })
                        gsap.set(q('.img-wrap .img'), { autoAlpha: 0 })
                        gsap.set(q('.img-wrap .img')[0], { autoAlpha: 1 });

                        tl.call(controlVideo, ['play', q('.img-wrap .img'), 0], '<');

                        for (var i=0; i<cardLength; i++) {
                            tl.to(q('.txt-wrap .txt-desc')[i], {
                                marginTop: function() { return ('-=' + txtHeight / 2) },
                                duration: 0.5,
                            }, '>');

                            tl.to(q('.img-wrap .img')[i+1], {
                                autoAlpha: 1,
                                duration: 0.1,
                                onComplete: controlVideo,
                                onCompleteParams: ['play', q('.img-wrap .img'), i+1],
                                onReverseComplete: controlVideo,
                                onReverseCompleteParams: ['pause', q('.img-wrap .img'), i+1],
                            }, '>-0.2');

                            tl.to(q('.img-wrap .img')[i], {
                                autoAlpha: 0,
                                duration: 0.1,
                                onComplete: controlVideo,
                                onCompleteParams: ['pause', q('.img-wrap .img'), i],
                                onReverseComplete: controlVideo,
                                onReverseCompleteParams: ['play', q('.img-wrap .img'), i],
                            }, '>-0.1');

                            tl.to(q('.txt-wrap .txt-desc')[i], {
                                marginTop: function() { return ('-=' + txtHeight / 2) },
                                duration: 0.5,
                            }, '>');
                        }
                    });
                },
            });

            // Concept Card - Animation type
            ScrollTrigger.matchMedia({
                // 모바일
                "(max-width: 767px)": function() {
                    gsap.utils.toArray('.usp-card.animation-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);
                        var tl1 = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                // markers: true,
                                start: '50% bottom',
                                end: '52% bottom',
                                // scrub: true,
                                toggleActions: 'play complete reverse reset',
                                invalidateOnRefresh: true,
                            },
                            defaults: {
                                ease: 'none',
                            },
                        });
                        var tl2 = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                // markers: true,
                                start: '80% bottom',
                                end: '82% bottom',
                                scrub: true,
                                toggleActions: 'play complete reverse reset',
                                invalidateOnRefresh: true,
                            },
                            defaults: {
                                ease: 'none',
                            },
                        });

                        gsap.set(q('.txt-wrap .txt-desc'), { autoAlpha: 0, });
                        gsap.set(q('.txt-wrap .txt-desc')[0], { autoAlpha: 1, });
                        gsap.set(q('.img-wrap .img'), { autoAlpha: 0, });
                        gsap.set(q('.img-wrap .img')[0], { autoAlpha: 1, });

                        tl1.call(controlVideo, ['play', q('.img-wrap .img'), 0], '<');

                        tl1.to(q('.txt-wrap .txt-desc')[0], {
                            autoAlpha: 0,
                            duration: 0.5,
                        });

                        tl1.to(q('.txt-wrap .txt-desc')[1], {
                            autoAlpha: 1,
                            duration: 0.5,
                        }, '<');

                        tl1.to(q('.img-wrap .img')[1], {
                            autoAlpha: 1,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['play', q('.img-wrap .img'), 1],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['pause', q('.img-wrap .img'), 1],
                        }, '<');

                        tl1.to(q('.img-wrap .img')[0], {
                            autoAlpha: 0,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['pause', q('.img-wrap .img'), 0],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['play', q('.img-wrap .img'), 0],
                        }, '>');

                        tl2.to(q('.img-wrap .img')[2], {
                            autoAlpha: 1,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['play', q('.img-wrap .img'), 2],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['pause', q('.img-wrap .img'), 2],
                        });

                        tl2.to(q('.txt-wrap .txt-desc')[1], {
                            autoAlpha: 0.5,
                            duration: 0.5,
                        }, '<');

                        tl2.to(q('.txt-wrap .txt-desc')[2], {
                            autoAlpha: 1,
                            duration: 0.5,
                        }, '<');

                        tl2.to(q('.img-wrap .img')[1], {
                            autoAlpha: 0,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['pause', q('.img-wrap .img'), 1],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['play', q('.img-wrap .img'), 1],
                        }, '>');
                    });
                },

                // PC
                "(min-width: 768px)": function() {
                    gsap.utils.toArray('.usp-card.animation-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);
                        var tl1 = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                // markers: true,
                                start: '30% 50%',
                                end: '40% 50%',
                                // scrub: true,
                                toggleActions: 'play complete reverse reset',
                                invalidateOnRefresh: true,
                            },
                            defaults: {
                                ease: 'none',
                            },
                        });
                        var tl2 = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                // markers: true,
                                start: '60% 50%',
                                end: '70% 50%',
                                // scrub: true,
                                toggleActions: 'play complete reverse reset',
                                invalidateOnRefresh: true,
                            },
                            defaults: {
                                ease: 'none',
                            },
                        });

                        gsap.set(q('.txt-wrap .txt-desc'), { autoAlpha: 0, });
                        gsap.set(q('.txt-wrap .txt-desc')[0], { autoAlpha: 1, });
                        gsap.set(q('.img-wrap .img'), { autoAlpha: 0, });
                        gsap.set(q('.img-wrap .img')[0], { autoAlpha: 1, });

                        tl1.call(controlVideo, ['play', q('.img-wrap .img'), 0], '<');

                        tl1.to(q('.txt-wrap .txt-desc')[0], {
                            autoAlpha: 0,
                            duration: 0.5,
                        });

                        tl1.to(q('.txt-wrap .txt-desc')[1], {
                            autoAlpha: 1,
                            duration: 0.5,
                        }, '<');

                        tl1.to(q('.img-wrap .img')[1], {
                            autoAlpha: 1,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['play', q('.img-wrap .img'), 1],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['pause', q('.img-wrap .img'), 1],
                        }, '<');

                        tl1.to(q('.img-wrap .img')[0], {
                            autoAlpha: 0,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['pause', q('.img-wrap .img'), 0],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['play', q('.img-wrap .img'), 0],
                        }, '>');

                        tl2.to(q('.img-wrap .img')[2], {
                            autoAlpha: 1,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['play', q('.img-wrap .img'), 2],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['pause', q('.img-wrap .img'), 2],
                        });

                        tl2.to(q('.txt-wrap .txt-desc')[1], {
                            autoAlpha: 0,
                            duration: 0.5,
                        }, '<');

                        tl2.to(q('.txt-wrap .txt-desc')[2], {
                            autoAlpha: 1,
                            duration: 0.5,
                        }, '<');

                        tl2.to(q('.img-wrap .img')[1], {
                            autoAlpha: 0,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['pause', q('.img-wrap .img'), 1],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['play', q('.img-wrap .img'), 1],
                        }, '>');
                    });
                },
            });

            // Concept Card - Video type
            ScrollTrigger.matchMedia({
                // 모바일
                "(max-width: 767px)": function() {
                    gsap.utils.toArray('.usp-card.video-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);
                        var tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                // markers: true,
                                start: 'top 20%',
                                end: 'top 15%',
                                // scrub: true,
                                toggleActions: 'play complete reverse reset',
                                invalidateOnRefresh: true,
                            },
                            defaults: {
                                ease: 'none',
                            },
                        });

                        gsap.set(q('.txt-wrap .txt-desc'), { autoAlpha: 0, });
                        gsap.set(q('.txt-wrap .txt-desc')[0], { autoAlpha: 1, });
                        gsap.set(q('.img-wrap .img'), { autoAlpha: 0, });
                        gsap.set(q('.img-wrap .img')[0], { autoAlpha: 1, });

                        tl.call(controlVideo, ['play', q('.img-wrap .img'), 0], '<');

                        tl.to(q('.txt-wrap .txt-desc')[0], {
                            autoAlpha: 0,
                            duration: 0.5,
                        });

                        tl.to(q('.txt-wrap .txt-desc')[1], {
                            autoAlpha: 1,
                            duration: 0.5,
                        }, '<');

                        tl.to(q('.img-wrap .img')[1], {
                            autoAlpha: 1,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['play', q('.img-wrap .img'), 1],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['pause', q('.img-wrap .img'), 1],
                        }, '<');

                        tl.to(q('.img-wrap .img')[0], {
                            autoAlpha: 0,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['pause', q('.img-wrap .img'), 0],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['play', q('.img-wrap .img'), 0],
                        }, '>');
                    });
                },

                // PC
                "(min-width: 768px)": function() {
                    gsap.utils.toArray('.usp-card.video-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);
                        var tl = gsap.timeline({
                            scrollTrigger: {
                                trigger: el,
                                // markers: true,
                                start: '40% 50%',
                                end: '50% 50%',
                                // scrub: true,
                                toggleActions: 'play complete reverse reset',
                                invalidateOnRefresh: true,
                            },
                            defaults: {
                                ease: 'none',
                            },
                        });

                        gsap.set(q('.txt-wrap .txt-desc'), { autoAlpha: 0, });
                        gsap.set(q('.txt-wrap .txt-desc')[0], { autoAlpha: 1, });
                        gsap.set(q('.img-wrap .img'), { autoAlpha: 0, });
                        gsap.set(q('.img-wrap .img')[0], { autoAlpha: 1, });

                        tl.call(controlVideo, ['play', q('.img-wrap .img'), 0], '<');

                        tl.to(q('.txt-wrap .txt-desc')[0], {
                            autoAlpha: 0,
                            duration: 0.5,
                        });

                        tl.to(q('.txt-wrap .txt-desc')[1], {
                            autoAlpha: 1,
                            duration: 0.5,
                        }, '<');

                        tl.to(q('.img-wrap .img')[1], {
                            autoAlpha: 1,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['play', q('.img-wrap .img'), 1],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['pause', q('.img-wrap .img'), 1],
                        }, '<');

                        tl.to(q('.img-wrap .img')[0], {
                            autoAlpha: 0,
                            duration: 0.5,
                            onComplete: controlVideo,
                            onCompleteParams: ['pause', q('.img-wrap .img'), 0],
                            onReverseComplete: controlVideo,
                            onReverseCompleteParams: ['play', q('.img-wrap .img'), 0],
                        }, '>');
                    });
                },
            });

            // Feature Card - Normal type
            ScrollTrigger.matchMedia({
                // 모바일
                "(max-width: 767px)": function() {
                    gsap.utils.toArray('.usp-card.feature-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);

                        ScrollTrigger.create({
                            trigger: el,
                            start: 'top 50%',
                            end: 'bottom 10%',
                            invalidateOnRefresh: true,
                            onEnter: function() {
                                controlVideo('play', q('.img-wrap .img'), 0);
                            },
                            onEnterBack: function() {
                                controlVideo('play', q('.img-wrap .img'), 0);
                            },
                        });
                    });
                },

                // PC
                "(min-width: 768px)": function() {
                    gsap.utils.toArray('.usp-card.feature-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);

                        ScrollTrigger.create({
                            trigger: el,
                            start: '40% 90%',
                            end: 'bottom 10%',
                            invalidateOnRefresh: true,
                            onEnter: function() {
                                controlVideo('play', q('.img-wrap .img'), 0, true);
                            },
                            onEnterBack: function() {
                                controlVideo('play', q('.img-wrap .img'), 0, true);
                            },
                        });
                    });
                },
            });

            // Feature Card - Cover type
            ScrollTrigger.matchMedia({
                // 모바일
                "(max-width: 767px)": function() {
                    gsap.utils.toArray('.usp-card.cover-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);

                        ScrollTrigger.create({
                            trigger: el,
                            start: 'top 50%',
                            end: 'bottom 10%',
                            invalidateOnRefresh: true,
                            onEnter: function() {
                                controlVideo('play', q('.img-wrap .img'), 0);
                            },
                            onEnterBack: function() {
                                controlVideo('play', q('.img-wrap .img'), 0);
                            },
                        });
                    });
                },

                // PC
                "(min-width: 768px)": function() {
                    gsap.utils.toArray('.usp-card.cover-type-wrap').forEach(function(el) {
                        var q = gsap.utils.selector(el);

                        ScrollTrigger.create({
                            trigger: el,
                            start: '40% 90%',
                            end: 'bottom 10%',
                            invalidateOnRefresh: true,
                            onEnter: function() {
                                controlVideo('play', q('.img-wrap .img'), 0, true);
                            },
                            onEnterBack: function() {
                                controlVideo('play', q('.img-wrap .img'), 0, true);
                            },
                        });
                    });
                },
            });

            // 비디오 정지
            ScrollTrigger.matchMedia({
                // 모바일
                "(max-width: 767px)": function() {
                    gsap.utils.toArray('.usp-card').forEach(function(el) {
                        var q = gsap.utils.selector(el);

                        ScrollTrigger.create({
                            trigger: el,
                            start: 'top bottom',
                            end: 'bottom top',
                            invalidateOnRefresh: true,
                            onLeave: function() {
                                $(el).find('video').each(function() {
                                    this.pause();
                                    this.currentTime = 0;
                                });
                            },
                            onLeaveBack: function() {
                                $(el).find('video').each(function() {
                                    this.pause();
                                    this.currentTime = 0;
                                });
                            },
                        });
                    });
                },

                // PC
                "(min-width: 768px)": function() {
                    gsap.utils.toArray('.usp-card').forEach(function(el) {
                        var q = gsap.utils.selector(el);

                        ScrollTrigger.create({
                            trigger: el,
                            start: 'top bottom',
                            end: 'bottom top',
                            invalidateOnRefresh: true,
                            onLeave: function() {
                                $(el).find('video').each(function() {
                                    this.pausedHover = false;
                                    $(this).off('.videoHover');
                                    this.pause();
                                    this.currentTime = 0;
                                });
                            },
                            onLeaveBack: function() {
                                $(el).find('video').each(function() {
                                    this.pausedHover = false;
                                    $(this).off('.videoHover');
                                    this.pause();
                                    this.currentTime = 0;
                                });
                            },
                        });
                    });
                },
            });
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC1100', isFirstLoad: false, fn: function () {
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();


    $(window).ready(function(){
        SAVE_COMPONENT_PDP_DOM_MNG();

        funcReady();
    });

})();

